import { getService } from "../../../shared/react/utils";

export const goToNextStep = ({ lotId, step }) => {
  const $state = getService("$state");
  $state.go("edit-property-step", { lotId, step }, { location: "replace" });
};
